import {
  CheckIcon,
  CircularIndicatorState,
  Container,
  StepText,
} from './CircularIndicator.styles';

interface Props {
  state: CircularIndicatorState;
  step: number;
  variant: 'text' | 'icon';
  'data-testid'?: string;
}

export const CircularIndicator = (props: Props) => (
  <Container data-testid={props['data-testid']} {...props}>
    {props.variant === 'icon' ? (
      <CheckIcon className="uil uil-check" size="24px" />
    ) : (
      <StepText {...props} data-testid={`${props['data-testid']}-text`}>
        {props.step}
      </StepText>
    )}
  </Container>
);
